/* Uncomment line below if you need jQuery */
import $ from 'jquery';

export const Static__LoadedEveryWhere = () => {
   var playerList = $('.gamePlayer__list');

   $(document).on('click', '.showPlayer ', function() {
      $(this).addClass('inactive'); 
      $('.hidePlayer').removeClass('inactive');
      playerList.removeClass('is-contracted');
   });

   $(document).on('click', '.hidePlayer ', function() {
      $(this).addClass('inactive'); 
      $('.showPlayer').removeClass('inactive');
      playerList.addClass('is-contracted');
   });
}